import React, { useState, useEffect } from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Button,
    Checkbox,
    SimpleGrid,
    VStack,
    HStack,
    Text,
    Divider,
} from '@chakra-ui/react';
import { ALL_COLUMNS, DEFAULT_COLUMN_KEYS } from './columnsConfig';

interface ColumnVisibilityModalProps {
    isOpen: boolean;
    onClose: () => void;
    visibleColumns: string[];
    onChangeColumns: (cols: string[]) => void;
}

export const ColumnVisibilityModal: React.FC<ColumnVisibilityModalProps> = ({
    isOpen,
    onClose,
    visibleColumns,
    onChangeColumns,
}) => {
    // Local state agar tabel tidak re-render/ter-apply sebelum tombol "Terapkan" ditekan
    const [tempColumns, setTempColumns] = useState<string[]>(visibleColumns);

    useEffect(() => {
        if (isOpen) {
            setTempColumns(visibleColumns);
        }
    }, [isOpen, visibleColumns]);

    const handleToggle = (key: string) => {
        if (tempColumns.includes(key)) {
            setTempColumns(tempColumns.filter((c) => c !== key));
        } else {
            setTempColumns([...tempColumns, key]);
        }
    };

    const handleSelectAll = () => {
        setTempColumns(ALL_COLUMNS.map((c) => c.key as string));
    };

    const handleClearAll = () => {
        setTempColumns([]);
    };

    const handleResetDefault = () => {
        setTempColumns(DEFAULT_COLUMN_KEYS);
    };

    const handleApply = () => {
        onChangeColumns(tempColumns);
        onClose();
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="xl" scrollBehavior="inside">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader fontSize="md">Pilih Kolom Tampilan Tabel</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <VStack align="stretch" spacing={3}>
                        <HStack justify="space-between">
                            <Text fontSize="xs" color="gray.500">
                                pilih field yang ingin ditampilkan pada tabel.
                            </Text>
                            <HStack spacing={2}>
                                <Button size="xs" variant="ghost" colorScheme="red" onClick={handleClearAll}>
                                    Hapus Semua
                                </Button>
                                <Button size="xs" variant="ghost" onClick={handleResetDefault}>
                                    Reset Default
                                </Button>
                                <Button size="xs" variant="ghost" colorScheme="blue" onClick={handleSelectAll}>
                                    Pilih Semua
                                </Button>
                            </HStack>
                        </HStack>

                        <Divider />

                        <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} spacing={3}>
                            {ALL_COLUMNS.map((col) => {
                                const key = col.key as string;
                                const isChecked = tempColumns.includes(key);
                                return (
                                    <Checkbox
                                        key={key}
                                        size="sm"
                                        isChecked={isChecked}
                                        onChange={() => handleToggle(key)}
                                    >
                                        <Text fontSize="xs">{col.label}</Text>
                                    </Checkbox>
                                );
                            })}
                        </SimpleGrid>
                    </VStack>
                </ModalBody>
                <ModalFooter>
                    <HStack spacing={2}>
                        <Button size="sm" variant="ghost" onClick={onClose}>
                            Batal
                        </Button>
                        <Button size="sm" colorScheme="blue" onClick={handleApply}>
                            Terapkan Kolom ({tempColumns.length} Kolom Aktif)
                        </Button>
                    </HStack>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};
